import axios from 'axios'
import magentoCategories from './magentoCategories.json'

const mockPromise = (success, duration = 2000) => new Promise((resolve) => {
  setTimeout(() => resolve(success), duration)
})

export default class inCartApis {

  /*eslint-disable */
  // baseURL will be set when successfully fetch preferences
  config = {}

  static set setConfig(value) {
    // console.log('value', value)
    inCartApis.config = value
  }

  static request(config){
    return axios({
      ...config,
      baseURL: inCartApis.config.baseURL,
      headers: {
        'x-auth-token': inCartApis.config.accessToken,
        'x-store-token': inCartApis.config.storeToken,
        'x-api-key': inCartApis.config.apiKey,
        ...config.headers,
      },
    })
      .then(({ data }) => {
        return data
      })
      .catch((error) => {
        if (error.response) {
          throw { error: error.response.data.error, status: error.status } // eslint-disable-line no-throw-literal
        } else {
          throw error
        }
      })
  }

  static getMagentoCategories() {
    return inCartApis.request({
      method: 'GET',
      url: `${inCartApis.config.categoriesPath}`,
    })
  }

  static getProduct(sku) {
    return inCartApis.request({
      method: 'GET',
      url: `${inCartApis.config.productsPath}/${sku}`
    })
  }

  static getProductList(skuList) {
    return Promise.all(
      skuList.map(inCartApis.getProduct)
    ).then((products) => products.map(({ data }) => data))
  }
}


// WEBPACK FOOTER //
// ./src/apis/incartApis.js